<template>
  <v-card class="my-auto" outlined>
    <v-list-item two-line>
      <v-list-item-content>
        <v-container>
          <v-row>
            <v-col cols="12">
              <div>
                <v-progress-circular
                  v-if="showLoading"
                  top
                  :style="{
                    position: 'absolute',
                    left: '40%',
                    top: '35%',
                    transform: 'translateX(-50%);translateY(-50%);',
                  }"
                  :size="70"
                  :width="7"
                  color="purple"
                  indeterminate
                ></v-progress-circular>

                <Bar
                  v-if="hasReadData"
                  timeUnit="month"
                  displayFormat="D"
                  :chart-id="title"
                  :chart-data="myChartData"
                  :chart-options="myChartOptions"
                />
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-list-item-content>
    </v-list-item>
  </v-card>
</template>

<script lang="ts">
import { Component, Prop, PropSync, Vue, Watch } from "vue-property-decorator";
import axios from "axios";
import { IPortfolioChartRef, ILine, IDataPoint } from "./ChartInterfaces";
import { sprintf } from "sprintf-js";
import { DateTime } from "luxon";
import {
  dateRangeForLastMonth,
  sma,
  get_last_number_of_elements,
} from "@/common";
import "chartjs-adapter-luxon";

import { Bar } from "vue-chartjs/legacy";

import BaseChart from "./Chart.vue";
import { AveragingType, EnumProp } from "./Chart.vue";

@Component({
  components: { Bar },
})
export default class BarChartLast12MonthsFromCsv extends BaseChart {
  @Prop(EnumProp(AveragingType.None, AveragingType))
  // @Prop({default: '', type: String}) public csv_path!: string;
  public averaging_type!: AveragingType;

  constructor() {
    super();
    this.hasReadData = false;
  }

  // curl -X POST http://carneab4.memset.net:1337/hisRead -H "authorization: BEARER authToken=PKLivoIgkH390hiKHOAutagi2Emfd5"
  // --data $'ver:"3.0" granularity:"second" aggregate:"avg"\nid,range\n[@9941983, @9941936],"2020-09-02"'
  protected async readData(): Promise<any> {
    const self = this;

    // self.xMinShadowed = self.startDateTime;

    console.log("getting file", self.url);

    const csv_data = await self.$store.dispatch(
      "requestStaticFileForSiteGroupId",
      { product: "tagged_portfolio_generator", filename: self.url },
      { timeout: 30000 }
    );

    if (csv_data == null) {
      self.showLoading = false;
      return false;
    }

    const lines = csv_data.split("\n");

    const header = lines[0];
    const header_fields = header.split(",");
    const dataset_count = header_fields.length - 1;

    let datasets: object[][] = []
    
    // console.log("here");

    for (let dataset=1; dataset <= dataset_count; dataset++) {

      let data: IDataPoint[] = [];

      for (const line of lines.slice(1)) {

        if(line === undefined || line === '') {
          continue;
        }

        const fields = line.split(",");

        const dt = DateTime.fromFormat(
          fields[0],
          "yyyy-MM-dd"
        )
     //     .startOf("month")
          .toUTC();

        let value = parseFloat(fields[dataset]);

        data.push({x: dt, y: value});
      }

      
      datasets.push(data);
    }

    self.data = datasets;

    self.hasReadData = true;
    self.showLoading = false;

    return true;
  }

  // private get startDateTime(): string {
  //   return DateTime.now()
  //     .toUTC()
  //     .minus({ months: 13 })
  //     .toFormat("yyyy-MM-dd'T'HH:mm:ss");
  // }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="css">
[v-cloak] {
  display: none;
}
</style>